<div class="info-card-col">
  <div class="form-floating">
    <label for="{{ id() }}">{{ label() | translate }}</label>
    <input
      class="form-control no-border"
      type="text"
      placeholder="-"
      readonly
      id="{{ id() }}"
      [ngStyle]="{ 'min-width': minWidth() }"
      [value]="value() | translate"
      [attr.data-test]="dataTest()"
    />
  </div>
</div>
